module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/bnr_chapel_photo-61f2895544659db55e03a36ff893d6e4.jpg";